export enum ExtensionStorageKeys {
  ClinicId = "kahun-x:clinicId",
  ClinicName = "kahun-x:clinicName",
  Debug = "kahun-x:debug",
  Quited = "kahun-x:quit",
  AutoOpenPatientCase = "kahun-x:autoOpenCase",
  LastClose = "kahun-x:lastCloseTimestamp",
  DialogDemoMode = "kahun-x:internal:isDemoMode",
  RagApp = "kahun-x:internal:ragApp",
  Size = "kahun-x:internal:size",
  Position = "kahun-x:internal:position",
  //...
}

export enum ExtensionStorageValueTypes {
  String = "string",
  Boolean = "boolean",
  Hidden = "hidden",
}

export const ExtensionStorageKeyTypes: Record<
  ExtensionStorageKeys,
  ExtensionStorageValueTypes
> = {
  [ExtensionStorageKeys.Debug]: ExtensionStorageValueTypes.Boolean,
  [ExtensionStorageKeys.ClinicId]: ExtensionStorageValueTypes.String,
  [ExtensionStorageKeys.AutoOpenPatientCase]:
    ExtensionStorageValueTypes.Boolean,
  [ExtensionStorageKeys.ClinicName]: ExtensionStorageValueTypes.String,
  // Last close is an internal value, not a setting
  [ExtensionStorageKeys.LastClose]: ExtensionStorageValueTypes.Hidden,
  [ExtensionStorageKeys.Quited]: ExtensionStorageValueTypes.Hidden,
  [ExtensionStorageKeys.DialogDemoMode]: ExtensionStorageValueTypes.Boolean,
  [ExtensionStorageKeys.RagApp]: ExtensionStorageValueTypes.String,
  [ExtensionStorageKeys.Size]: ExtensionStorageValueTypes.Hidden,
  [ExtensionStorageKeys.Position]: ExtensionStorageValueTypes.Hidden,
};
